<script setup>
import Footer from '@/components/Footer.vue';
import BlockILEM from '@/components/BlockILEM.vue';
import { onMounted } from 'vue';

onMounted(async () => {
  document.title = "I Love English";
});

</script>

<template>
  <div class="app-layout jungle-layout">
    <BlockILEM />
    <Footer
      :logo-path="'ILEM/LogoBayard.svg'"
      faqColor="#2e2818"
      localeSelectColor="#2e2818"
      faqImagePath="ILEM/help_icon_yellow.svg" />
  </div>
</template>
